module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1600@2x-6e0476db90194b0f29fc9410d54537f4.webp";